import { useEffect, useState } from "react"
import SubmitButton from "../../components/assets/inputs/SubmitButton"
import TextArea from "../../components/assets/inputs/TextArea"
import TextInput from "../../components/assets/inputs/TextInput"
import Mail from "../../components/icons/Mail"
import Marker from "../../components/icons/Marker"
import Phone from "../../components/icons/Phone"
import clsx from "clsx"
import axios from "axios"
import { BASE_URL, CONTACT_URL } from "../../globals"

export default function Contact() {
    const [email,setEmail] = useState("");
    const [name,setName] = useState("");
    const [subject,setSubject] = useState("");
    const [message,setMessage] = useState("");
    const [isLoading,setIsLoading] = useState(false);
    const [resultMessage,setResultMessage] = useState(null);

    async function handleSubmit(e){
        e.preventDefault();
        setIsLoading(true);
        setResultMessage(null);
        try{
            const response = await axios.get(`${CONTACT_URL}/get-nonce`);
            const nonce = response.data.nonce;
            const data = {
                name,
                email,
                subject,
                message,
                nonce
            }
            await axios.post(`${CONTACT_URL}/submit`,data,{
                headers: {
                    "Content-Type":"application/json"
                }
            });
            resetValues();
        } catch(err){

        }
        setIsLoading(false);
    }

    function resetValues(){
        setName("");
        setEmail("");
        setSubject("");
        setMessage("");
        setTimeout(()=>{
            setResultMessage("Message envoyé avec succès !");
        },500);
    }

    useEffect(()=>{
        setResultMessage(null);
    },[email,name,subject,message]);

    return (
        <div className="px-6 py-16 flex flex-col gap-[6.25rem] items-center max-w-[1661px] mx-auto">
            <div className="text-center flex flex-col items-center gap-[1.75rem] text-balance">
                <h2 className="font-bold text-heading-2 leading-[100%] mobile:text-heading-4">
                    Prenez contact avec notre équipe de neuils !
                </h2>
                <p className="text-large font-bold">
                    On va pas faire un test de vue ni vous prêter des lunettes mais on peut vous montrer la voie d’une bonne communication !
                </p>
            </div>
            <div className="flex gap-[6rem] tablet:flex-col-reverse items-end tablet:items-center">
                <div className="basis-1/2 flex flex-col gap-[1.875rem]">
                    <div className="tablet:text-center flex flex-col gap-[1rem] text-balance">
                        <h3 className="text-heading-3 font-bold leading-[100%] mobile:text-heading-4">
                            Envoyez nous votre message
                        </h3>
                        <p className="mobile:text-large">Glisse dans nos DM pour qu’ensemble on créé et boost ton projet pour te permettre d’atteindre les sommets !</p>
                    </div>
                    <form className="flex flex-col gap-[1.875rem] tablet:mt-6" onSubmit={handleSubmit}>
                        <div className="flex gap-[1.875rem] mobile:flex-col">
                            <TextInput
                                placeholder="Nom et prénom"
                                type="text"
                                required
                                value={name}
                                changeHandler={setName}
                            />
                            <TextInput
                                placeholder="Email"
                                type="email"
                                required
                                value={email}
                                changeHandler={setEmail}
                            />
                        </div>
                        <TextInput
                            placeholder="Sujet"
                            type="text"
                            required
                            value={subject}
                            changeHandler={setSubject}
                        />
                        <TextArea
                            placeholder="Votre message..." 
                            required
                            value={message}
                            changeHandler={setMessage}/>
                        <SubmitButton loading={isLoading}>
                            Envoyer mon message
                        </SubmitButton>
                    </form>
                    {resultMessage && <p className="text-center text-zoeil-blue mt-1">{resultMessage}</p>}
                </div>
                <div className="basis-1/2 flex flex-col gap-[1.875rem]">
                    <ContactCard
                        title={"Il faut bien un contact sérieux."}
                        label={"contact@zoeil-agence.com"}
                        href={"mailto:contact@zoeil-agence.com"}
                        className={"bg-zoeil-pink"}
                        icon={<Mail />}
                    />
                    <ContactCard
                        title={"On le donne pas à n’importe qui !"}
                        label={"06 12 81 75 26"}
                        href={"tel:0612817526"}
                        className={"bg-zoeil-yellow"}
                        icon={<Phone />}
                    />
                    <ContactCard
                        title={"Préviens avant de passer dire bonjour !"}
                        label={"36 rue des Tilleuls, 59650, Villeneuve d’ascq"}
                        href={"#"}
                        className={"bg-zoeil-blue"}
                        icon={<Marker />}
                    />
                </div>
            </div>
        </div>
    )
}

function ContactCard(
    {
        title,
        label,
        href,
        icon,
        className
    }
) {
    return (
        <div className={clsx(
            "flex text-white px-[1.875rem] py-[2.1875rem] gap-[2.1875rem]",
            className
        )}>
            <div className="w-[4.6875rem] aspect-square">
                {icon}
            </div>
            <div className="flex flex-col gap-[1rem]">
                <h4 className="text-large font-[500] mobile:text-regular">
                    {title}
                </h4>
                <a href={href} className="text-heading-5 small-computer:text-heading-6 font-bold leading-[100%] mobile:text-very-large">
                    {label}
                </a>
            </div>
        </div>
    )
}